import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "horizontal"
}

import { ref, onMounted, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CLoadingIndicator',
  props: {
    type: { default: 'circle' },
    size: { default: '' },
    show: { type: Boolean, default: false }
  },
  setup(__props: any) {

// TODO vue3: replace component with t-progress !?
const props = __props
let timer: NodeJS.Timer
const off = ref(false)

onMounted(() => {
  // this is required to not show the animation in case off show is initial false
  if (props.show === false) {
    off.value = true
  } else {
    off.value = false
  }
})

watch(
  () => props.show,
  () => {
    if (!props.show) {
      setTimeout(() => {
        // this.$refs.loadingIndicator.style.display = this.show ? "flex" : "none"
        off.value = true
      }, 500)
    } else {
      off.value = false
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-qe-id": "loader-indicator",
    ref: "loadingIndicator",
    class: _normalizeClass(["loadingIndicator", `${_ctx.show ? 'active' : 'inactive'} ${off.value ? 'off' : ''}`])
  }, [
    (_ctx.type === 'circle')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["circle", _ctx.size])
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.type === 'horizontal')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "horizontal--bounce1" }, null, -1),
          _createElementVNode("div", { class: "horizontal--bounce2" }, null, -1),
          _createElementVNode("div", { class: "horizontal--bounce3" }, null, -1)
        ])))
      : _createCommentVNode("", true)
  ], 2))
}
}

})